import { checkPage, isAuthorMode, isLocalDomain } from '../../utils/aem-utils';
import { isRefreshHPDisabled } from '../../utils/page-refresh';

export const pageRefreshModule = {
  name: 'Page Refresh',
  shouldInit: () =>
    checkPage('home-page', document.body) && !isAuthorMode() && !isLocalDomain() && !isRefreshHPDisabled(),
};
